module.exports = __webpack_public_path__ + "static/media/todolistScreen.cdb3f489.jpg";